module.exports = __webpack_public_path__ + "img/r-cb6-1.575e81b1.gif";